var chunkToChildrenMap = {
	"132": [
		8395
	],
	"3470": [
		8395
	],
	"5619": [
		8395
	],
	"7399": [
		8395
	],
	"8740": [
		8395
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));